import debounce from 'debounce';

const handleResizeObserver = (entries) => {
    entries.forEach((entry) => {
        document.documentElement.style.setProperty('--main-header-height', `${entry.contentRect.height}px`);
    })
};
const debounceHandleResizeObserver = debounce(handleResizeObserver, 300);
const header = document.getElementById('main-header');

if (header !== null) {
    const resizeObserver = new ResizeObserver(debounceHandleResizeObserver);

    resizeObserver.observe(header);
}
